import { useEffect, useRef } from 'react'

import { StatusVocabulary } from 'constants/data'
import { LocalStorageKeys } from 'constants/storage'
import { SECOND } from 'constants/timeslot'

const TIMEOUT = 5 * SECOND
const DEFAULT_NMO_TIME = 2700000
const STORAGE_KEY = LocalStorageKeys.WEBINAR_WATCH_TIME

const getStorageData = (arrayKey: string, id: number) => {
  const storage = localStorage.getItem(arrayKey)
  const data = storage ? JSON.parse(storage) : {}
  const prevTime = Number(data[id]) || 0
  return [prevTime, data]
}

const useNMOWatched = (
  id: number,
  webinarStatus: number,
  NMOTimeLength: number = DEFAULT_NMO_TIME
) => {
  const timeoutRef = useRef<any>(null)

  const clearTimer = () => {
    clearTimeout(timeoutRef.current)
    timeoutRef.current = null
  }

  const handleNMOWatchTime = () => {
    clearTimer()
    const [prevTime, data] = getStorageData(STORAGE_KEY, id)
    const newTime = prevTime + TIMEOUT

    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...data, [id]: newTime }))
    if (newTime < NMOTimeLength) {
      timeoutRef.current = setTimeout(() => handleNMOWatchTime(), TIMEOUT)
    }
  }

  useEffect(() => {
    if (webinarStatus === StatusVocabulary.ACTIVE) {
      const [prevTime] = getStorageData(STORAGE_KEY, id)

      if (prevTime < NMOTimeLength) {
        timeoutRef.current = setTimeout(() => handleNMOWatchTime(), TIMEOUT)
      }
    }

    return clearTimer
  }, [webinarStatus, id])
}

export default useNMOWatched
